<script>
export default {
  props: {
    title: {
      default: undefined,
      type: String,
    },
    content: {
      default: undefined,
      type: String,
    },
    date: {
      default: null,
      type: String,
    },
    headingTag: {
      default: 'a',
      type: String,
    },
    imgSrc: {
      default: undefined,
      type: String,
    },
    imgWidth: {
      default: '10rem',
      type: String,
    },
    mobileImgHeight: {
      default: '15rem',
      type: String,
    },
    border: {
      default: false,
      type: Boolean,
    },
    padding: {
      default: '1rem .5rem',
      type: String,
    },
    url: {
      default: '#!',
      type: String,
    },
  },
  computed: {
    /**
     * Card padding
     */
    cardPadding() {
      return {
        '--cardPadding': this.padding,
      }
    },
    /**
     * Width of an image
     */
    imageWidth() {
      return {
        '--cardImageWidth': this.imgWidth,
      }
    },
    mobileImageHeight() {
      return {
        '--mobileImageHeight': this.mobileImgHeight,
      }
    },
  },
  methods: {
    toSingle: function(url) {
      this.$router.push({ path: url })
    },
  },
}
</script>

<template>
  <div
    :class="[$style.newsCard, border !== false ? $style.hasBorder : '']"
    :style="[imageWidth, cardPadding]"
  >
    <img
      v-if="imgSrc"
      v-lazy="imgSrc"
      :alt="title + '-image'"
      :class="$style.cardImage"
      srcset=""
    />
    <div :class="$style.cardContent">
      <router-link
        v-if="headingTag === 'a'"
        :to="url"
        :class="[$style.headingTitle, $style.normalHeading]"
      >
        {{ title }}
      </router-link>
      <component
        :is="headingTag"
        v-else
        :class="$style.headingTitle"
        @click="toSingle(url)"
      >
        {{ title }}
      </component>
      <span v-if="date" class="date" :style="{ color: 'gray' }">
        <small
          ><i>{{ date }}</i></small
        >
      </span>
      <div v-html-safe="content" class="my-3"></div>
      <router-link :to="url">{{ $t('read_more') }}</router-link>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.newsCard {
  display: flex;
  padding: var(--cardPadding);
  margin: 1rem 0;
  background-color: #fff;
  border-radius: $radius;
  box-shadow: 1px 3px 15px rgba(0, 0, 0, 0.1);
  &.hasBorder {
    border: 1px solid $gray;
  }
  .cardImage {
    width: var(--cardImageWidth);
    height: auto;
    object-fit: cover;
  }
  .cardContent {
    padding: 0 1.5rem;
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-weight: $medium;
      color: $primary;
      cursor: pointer;
    }
    .headingTitle {
      // font-size: 1.9rem;
      font-weight: $medium;
      line-height: 1.5;
      color: $primary;
      cursor: pointer;
      &.normalHeading {
        display: block;
        font-size: 1.5rem;
        text-decoration: none;
      }
    }
  }
}

@media only screen and (max-width: $mobile-sm) {
  .newsCard {
    flex-direction: column;
    padding: 0;
    &.hasBorder {
      border: 2px solid $gray;
    }
    .cardImage {
      width: 100%;
      max-height: var(---mobileImageHeight);
      border-top-left-radius: $radius;
      border-top-right-radius: $radius;
    }
    .cardContent {
      padding: 1.5rem;
    }
  }
}
</style>
